module.exports = __webpack_public_path__ + "static/media/VerifiedLicense.295be8c4.svg";